export default function searchTermCleanser(string) {
  return string
    .toLowerCase()
    .trim()
    .replace(/<\/?[^>]+(>|$)/g, "");
}



// WEBPACK FOOTER //
// ./template/helpers/searchTermCleanser.js